module.exports = __webpack_public_path__ + "img/pumauta.bfd5edb3.jpg";